import { Examen } from 'src/app/examen/models/examen';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SidebarOptionComponent } from "./sidebar-option/sidebar-option.component";
import {MatButtonModule} from '@angular/material/button';
import {MatSidenavModule} from '@angular/material/sidenav';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import {MatSelectModule} from '@angular/material/select';
import { SidebarServiceService } from './service/sidebar-service.service';
import { AlertComponent } from '../alert/alert.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { User_info_auth } from 'src/app/authentication/models/user_info';
import { AuthenticationService } from 'src/app/authentication/services/authentification.service';
import { MatDivider } from '@angular/material/divider';


interface ItemSearch{
  name : string
  path : string
  rigth : string
}

interface SearchI{
  group: string
  item : ItemSearch[]
}

@Component({
    selector: 'app-sidebar',
    imports: [
        MatButtonModule,
        MatSidenavModule,
        MatSelectModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatAutocompleteModule,
        MatDivider,
        //
        AlertComponent,
        //
        RouterModule,
        SidebarOptionComponent,
        ReactiveFormsModule,
        AsyncPipe,
        NgIf
    ],
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})


export class SidebarComponent implements AfterViewInit{

  /* Ce tableau contient les id's des differents elements presents dans le hoverbar.
      Il est utilise pour afficher un contenu dynamique dans la barre selon l'element
      selectionne dans le sidebar.
  */
 currentUser: User_info_auth;

  @ViewChild('startOfSidebar')startOfSidebar !: ElementRef;
  @ViewChild('searchInput')searchInput !: ElementRef;

  searchList : SearchI[];
  search = new FormControl('')
  filteredOption : Observable<ItemSearch []>
  showSearch = false

  aff = true
  openSidenav = false
  myContentSytle = 'padding-left: 4%;'


  constructor(private sb : SidebarServiceService, private router : Router, private authenticationService : AuthenticationService) {

    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.initSearchList()
    console.log(this.currentUser.profile['examens']);

   }

  ngOnInit(): void {
    this.filteredOption = this.search.valueChanges.pipe(
      startWith(''),
      map(val => this._filter(val || '')))
  }

  ngAfterViewInit(): void {
      this.sb.etat.subscribe(val =>{
        if(!val && this.openSidenav){
          this.openSidenav = false
          this.aff = !this.aff
          if(!this.aff){
            this.myContentSytle = 'padding-left: 1%;'
          }else{
            this.myContentSytle = 'padding-left: 4%;'
          }
        }
      })


  }

  private _filter(val : string) : ItemSearch []{
    let itemSearch : ItemSearch[] = []
    const filterValue = val.toLocaleLowerCase();

    if(val=="")return []

    this.searchList.map(x => x.item.map((y : ItemSearch) => {
        if(y.name.toLocaleLowerCase().includes(filterValue))
            itemSearch.push(y)
    }))

    return itemSearch

  }

  initSearchList(){
    this.sb.getSearchList().subscribe({
      next : (data : SearchI[]) =>{
        this.searchList = data
      }
    })
  }

  goToView(path : string){
    this.closeSidebar()
    this.router.navigate([path])
  }

  getRigth(rigth : string) : boolean{
    return this.currentUser.profile[rigth]??true
  }

  set setSearchBar(val : boolean){
    this.showSearch = val
  }

  get getSearchBar(){
    return this.showSearch
  }

  openSearchBar(){
    if(!this.showSearch){
      this.ScrollToTop()

    }

    this.setSearchBar = !this.showSearch
  }

  ScrollToTop(){
      setTimeout(() => {
        if(this.startOfSidebar){
          this.startOfSidebar.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          })
        }
        this.searchInput.nativeElement.focus()
      }, 500);
  }

  get getOpenSidenav(){
    return this.openSidenav
  }

  resetForm(){
    this.search.patchValue('')
  }

  closeSidebar(){
    this.sb.etat.next(false)
  }


  btnAff(){
    this.aff = !this.aff
    this.openSidenav = !this.openSidenav

    if(!this.aff){
      this.myContentSytle = 'padding-left: 1%;'
    }else{
      this.myContentSytle = 'padding-left: 4%;'
    }
  }

}
